import us from '../../defines';
import {isObject} from 'lodash';

/**
 * This is a generic x,y point object intended to expand to include common operations performed on x,y points.
 */
export class Point {
  x = 0;
  y = 0;

  constructor (x, y) {
    if (isObject(x)) {
      this.setPoint(x);
    } else {
      this.set(x, y);
    }
  }

  set (x = 0, y = 0) {
    this.x = Number(x);
    this.y = Number(y);
  }

  setPoint (cp) {
    this.set(cp.x, cp.y);
    return this;
  }

  add (dx, dy) {
    if (dy === undefined) {
      dy = dx;
    }
    this.x = this.x + Number(dx);
    this.y = this.y + Number(dy);
    return this;
  }

  addPoint (cp) {
    return this.add(cp.x, cp.y);
  }

  subtract (dx, dy) {
    if (dy === undefined) {
      dy = dx;
    }
    this.x = this.x - Number(dx);
    this.y = this.y - Number(dy);
    return this;
  }

  subtractPoint (cp) {
    return this.subtract(cp.x, cp.y);
  }

  multiply (dx, dy) {
    if (dy === undefined) {
      dy = dx;
    }
    this.x = this.x * dx;
    this.y = this.y * dy;
    return this;
  }

  // this method appears to be unused
  divide (dx, dy) {
    if (dy === undefined) {
      dy = dx;
    }
    this.x = this.x / dx;
    this.y = this.y / dy;
    return this;
  }

  cityBlockDistance (cpIn) {
    return Math.abs(cpIn.x - this.x) + Math.abs(cpIn.y - this.y);
  }

  distance (cpIn) {
    return Math.sqrt((cpIn.x - this.x) * (cpIn.x - this.x) + (cpIn.y - this.y) * (cpIn.y - this.y));
  }

  isEqual (cpIn) {
    return (cpIn.x === this.x && cpIn.y === this.y);
  }

  toInt () {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
  }

  toFixed (dec) {
    if (dec <= 0) {
      return this.toInt();
    }
    this.x = this.x.toFixed(dec);
    this.y = this.y.toFixed(dec);
    return this;
  }

  rotate (angleDeg) {
    const angleRad = angleDeg * us.Deg2Rad;
    const cosAngle = Math.cos(angleRad);
    const sinAngle = Math.sin(angleRad);

    const rotX = this.x * cosAngle - this.y * sinAngle;
    const rotY = this.x * sinAngle + this.y * cosAngle;
    this.x = rotX;
    this.y = rotY;
    return this;
  }

  rotateAbout (angleDeg, cpOrigin, precision = false) {
    this.subtractPoint(cpOrigin); // remove origin
    this.rotate(angleDeg);
    this.addPoint(cpOrigin); // restore origin

    if (precision !== false) {
      this.toFixed(precision);
    }
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/lib/objects/Point.js